import type { AvailabilityCode } from './AvailabilityCode'
import { availabilityResolverMap } from './availabilityResolverMap'

export const isAvailabilityCode = (value: string): value is AvailabilityCode =>
  Object.hasOwn(availabilityResolverMap.byCode, value)
